/* global $ */
/* eslint-disable react/forbid-dom-props */
import classnames from 'classnames';
import React from 'react';
import { TransitionGroup } from 'react-transition-group';
import withWindowScroll from '../../../utils/withWindowScroll';
import ClassActivatingTransition from '../ClassActivatingTransition';
import withTranslations from '../Translations/withTranslations';
import { getMirroredSide } from '../Translations/useLayoutDirection';
import styles from './PopoverContent.scss';
const MOBILE_BREAKPOINT = 768;
const MOBILE_EDGE_MARGIN = 20;
class PopoverContent extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.$popover = null;
        this.$content = null;
        this.popoverPosition = null;
        this.popoverSize = { width: 0, height: 0 };
        this.$window = window;
        this.popoverObserver = null;
        this.handleBodyClick = e => {
            const { hiding, onClose } = this.props;
            const $targetPopover = $(e.target).closest('.popover');
            if (!hiding && !$targetPopover.is(this.$popover) && onClose) {
                onClose(e);
            }
        };
        this.handleExited = () => {
            const { onFinishedHiding } = this.props;
            onFinishedHiding();
        };
        this.setPopoverContentRef = popoverContent => {
            this.$content = null;
            if (popoverContent) {
                this.$content = $(popoverContent);
                this.popoverObserver = this.popoverContentMutationObserver;
                this.popoverObserver.observe(this.$content[0], {
                    attributes: true,
                    childList: true,
                    characterData: true,
                });
                this.layout();
            }
        };
        this.setPopoverRef = popover => {
            this.$popover = null;
            if (popover) {
                this.$popover = $(popover);
                if (this.popoverPosition) {
                    this.$popover.css('left', this.popoverPosition.left);
                    this.$popover.css('top', this.popoverPosition.top);
                }
            }
        };
        this.layout = () => {
            const { anchorId, position, offsetTop, hasLockedPosition, isLayoutRTL, } = this.props;
            if (this.$content) {
                const $anchor = $(`#${anchorId}`);
                const coordinates = {
                    left: 0,
                    top: 0,
                };
                if ($anchor.length) {
                    const anchorPos = $anchor.offset();
                    const half = 0.5;
                    const center = 1.2;
                    const marginLeft = 10;
                    const resolvedPosition = getMirroredSide(position || 'left', isLayoutRTL);
                    switch (resolvedPosition) {
                        case 'top':
                            coordinates.left =
                                anchorPos.left - this.$content.outerWidth() * half;
                            coordinates.left += $anchor.outerWidth() * half;
                            coordinates.top = anchorPos.top - this.$content.outerHeight();
                            break;
                        case 'left':
                            coordinates.left = anchorPos.left - this.$content.outerWidth();
                            coordinates.top =
                                anchorPos.top - this.$content.outerHeight() * half;
                            break;
                        case 'bottom':
                            coordinates.left =
                                anchorPos.left - this.$content.outerWidth() * half;
                            coordinates.top = anchorPos.top + offsetTop;
                            break;
                        case 'right':
                            coordinates.left = anchorPos.left + $anchor.outerWidth();
                            coordinates.top =
                                anchorPos.top - this.$content.outerHeight() * half;
                            break;
                        case 'right-center':
                            coordinates.left =
                                anchorPos.left + $anchor.outerWidth() + marginLeft;
                            coordinates.top =
                                anchorPos.top - this.$content.outerHeight() * center;
                            break;
                        case 'left-center':
                            coordinates.left =
                                anchorPos.left - this.$content.outerWidth() - marginLeft;
                            coordinates.top =
                                anchorPos.top - this.$content.outerHeight() * center;
                            break;
                        case 'responsive':
                            coordinates.left = isLayoutRTL
                                ? anchorPos.left - this.$content.outerWidth()
                                : anchorPos.left + $anchor.outerWidth();
                            if (!isLayoutRTL) {
                                if (anchorPos.left +
                                    $anchor.outerWidth() +
                                    this.$content.outerWidth() >
                                    this.$window.innerWidth) {
                                    coordinates.left = anchorPos.left - this.$content.outerWidth();
                                }
                            }
                            else if (coordinates.left < 0) {
                                coordinates.left = anchorPos.left + $anchor.outerWidth();
                            }
                            coordinates.top =
                                anchorPos.top + offsetTop + $anchor.outerHeight();
                            if (anchorPos.top + offsetTop + this.popoverSize.height >
                                this.$window.innerHeight) {
                                coordinates.top =
                                    anchorPos.top - offsetTop - this.popoverSize.height;
                            }
                            break;
                        default:
                            coordinates.left = anchorPos.left - this.$content.outerWidth();
                            coordinates.top =
                                anchorPos.top - this.$content.outerHeight() * half;
                    }
                    const edgeMargin = window.innerWidth <= MOBILE_BREAKPOINT ? MOBILE_EDGE_MARGIN : 0;
                    const scrollLeft = window.pageXOffset;
                    const scrollTop = window.pageYOffset;
                    const visibleLeft = scrollLeft + edgeMargin;
                    const visibleRight = scrollLeft + window.innerWidth - edgeMargin;
                    const visibleBottom = scrollTop + window.innerHeight;
                    if (coordinates.left < visibleLeft) {
                        coordinates.left = visibleLeft;
                    }
                    else if (coordinates.left + this.$content.outerWidth() >
                        visibleRight) {
                        coordinates.left = Math.max(visibleLeft, visibleRight - this.$content.outerWidth());
                    }
                    if (coordinates.top < scrollTop) {
                        coordinates.top = scrollTop;
                    }
                    else if (!hasLockedPosition &&
                        coordinates.top + this.$content.outerHeight() > visibleBottom) {
                        coordinates.top = Math.max(scrollTop, visibleBottom - this.$content.outerHeight());
                    }
                }
                this.popoverPosition = coordinates;
                this.popoverSize = {
                    width: this.$content.outerWidth(),
                    height: this.$content.outerHeight(),
                };
                if (this.$popover) {
                    this.$popover.css('left', this.popoverPosition.left);
                    this.$popover.css('top', this.popoverPosition.top);
                }
            }
        };
    }
    componentDidMount() {
        document.body.addEventListener('click', this.handleBodyClick);
        this.props.setScrollHandler(this.layout);
        this.$window = window;
        this.layout();
    }
    componentWillUnmount() {
        document.body.removeEventListener('click', this.handleBodyClick);
        if (this.popoverObserver)
            this.popoverObserver.disconnect();
    }
    get popoverContentMutationObserver() {
        return new MutationObserver(mutations => {
            mutations.forEach(() => {
                const currentContentWidth = this.$content.outerWidth();
                const currentContentHeight = this.$content.outerHeight();
                if (this.popoverSize.width !== currentContentWidth ||
                    this.popoverSize.height !== currentContentHeight) {
                    this.layout();
                    this.popoverSize.width = currentContentWidth;
                    this.popoverSize.height = currentContentHeight;
                }
            });
        });
    }
    renderContent() {
        const { children, position, contentWrapperClassName, direction, isLayoutRTL, isCloseButton, isHoverPopover, onClose, } = this.props;
        const resolvedPosition = getMirroredSide(position || 'left', isLayoutRTL);
        return (<ClassActivatingTransition key="content" activateClassName="in" timeout={200} onExited={this.handleExited}>
        <div ref={this.setPopoverRef} className={classnames('popover fade', contentWrapperClassName, resolvedPosition, styles.popover, { [styles.hoverPopover]: isHoverPopover })} data-layout-direction={direction} dir={direction} onClick={this.handleBodyClick}>
          {isCloseButton && (<div className={styles.closeButtonPosition} style={{ textAlign: isLayoutRTL ? 'left' : 'right' }}>
              <button className="close" style={{ float: 'none' }} type="button" onClick={onClose}>
                ×
              </button>
            </div>)}
          <div ref={this.setPopoverContentRef} className={classnames('popover-content', isCloseButton && styles.popoverContentPadding)} data-layout-direction={direction} dir={direction}>
            {children}
          </div>
        </div>
      </ClassActivatingTransition>);
    }
    render() {
        const { hiding } = this.props;
        return (<TransitionGroup appear>
        {!hiding && this.renderContent()}
      </TransitionGroup>);
    }
}
PopoverContent.defaultProps = {
    isCloseButton: false,
    isHoverPopover: false,
    offsetTop: 0,
};
export default withWindowScroll(withTranslations(PopoverContent));
